module.exports = __webpack_public_path__ + "static/media/architecture-diagram-v0.1.bd17e96b.png";